import React from 'react';
import CustomSelect from "../form/CustomSelect";
import {useFilterContext} from "../../contexts/FilterContext";
import {useTranslation} from "react-i18next";

const PerPageFilter = ({className, inputStyles, defaultValue}) => {

    const { t } = useTranslation();

    const {name, filterValue, setFilterValue, updateURLParams } = useFilterContext();

    const availableRowsPerPageOptions = [
        {
            value: 10,
            label: '10'
        },
        {
            value: 20,
            label: '20'
        },
        {
            value: 50,
            label: '50'
        }
    ]

    const handleChange = (option) => {
        setFilterValue(option.value);
        updateURLParams(name, option.value);
    };

    return (
        <div className={`filter per-page-filter ${className}`}>
            <div className="d-inline-flex align-items-center">
                <span className="mr-1">{t("Rows")}:</span>
                <CustomSelect
                onChange={handleChange}
                style={inputStyles}
                placeholder={<div>{t("Rows")}:</div>}
                options={availableRowsPerPageOptions}
                value={
                    filterValue ? availableRowsPerPageOptions.filter(option => Number(option.value) === Number(filterValue)) :
                    defaultValue ? availableRowsPerPageOptions.filter(option => Number(option.value) === Number(defaultValue)) : ''
                }
            />
            </div>

        </div>
    );
};

export default PerPageFilter;
